// Вспомогательные функции для работы с форматами дат
export const DateUtils = {
    toISOLocal: (date) => {
        if (!date) return null;
        const d = new Date(date);
        return d.toISOString();
    },

    fromISO: (isoString) => {
        if (!isoString) return null;
        return new Date(isoString);
    },

    formatDateTime: (date) => {
        if (!date) return '';
        return new Date(date).toLocaleString('ru-RU');
    },
};

export const formatDates = (dateMS) => {
    const date = new Date(dateMS);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
};

// Конвертирует миллисекунды в ISO-строку (точность до миллисекунд)
export const ms2format = (ms) => {
    const date = new Date(ms);
    return date.toISOString();
};

// Конвертирует ISO-строку с точностью до микросекунд в миллисекунды
// Примеры:
// format2ms("2025-11-03T09:42:06.856307Z") → 1741160526856.307
// format2ms("2025-11-03T09:42:06.856307+03:00") → 1741149726856.307
// format2ms("2025-11-03T09:42:06.856Z") → 1741160526856.0
export const format2ms = (isoString) => {
    const date = new Date(isoString);
    return date.getTime();
};

